<!-- 供应商季度排名表 -->
<template>
  <div class="supplier-quarterly-ranking">
    <ls-table-layout>
      <div class="table-page-search-wrapper" slot="search">
        <ls-search-form :formList="formList" @search="onSearch"></ls-search-form>
      </div>
      <div class="table-page-operator-wrapper" slot="btn">
        <import-excel ref="importExcel" @onChange="importChange" @onSuccess="handleSuccess" :url="importExcelUrl"></import-excel>
        <download-modal :apiFun="apiScpMpsFdSupplierRankExport" ref="download" />
        <a-button @click="$refs.importExcel.show()" type="primary" v-if="$hasPermi(['fun_1833470920522874881_wfkmm'])">导入</a-button>
        <a-button @click="handleExport" type="primary" v-if="$hasPermi(['fun_1833470920522874881_KWSno'])">导出</a-button>
      </div>
      <template v-slot:table>
        <div class="page-header-content">
          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :tableProps="tableProps"
            rowKey="id"
            :scroll="{ fixScreen: true, x: 1300 }"
          >
            <template slot="createTime" slot-scope="{ text }">
              <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            </template>
            <template slot="scpSupplierCategory" slot-scope="{ text }">
              <span>{{ text=='10'?'外部':text=='15'?'内部':''}}</span>
            </template>
          </ls-api-table>
        </div>
      </template>
    </ls-table-layout>
  </div>
</template>

<script>
import { apiSelectSupplierRankPage, apiScpMpsFdSupplierRankExport } from '@/api/finished-goods-order'

import { generateLsTableResData } from '@/utils/util.js';
import importExcel from './importExcel.vue'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
export default {
  // eslint-disable-next-line
  name: 'Supplier-quarterly-ranking',
  components: {
    DownloadModal,
    importExcel
  },
  data () {
    return {
      apiScpMpsFdSupplierRankExport,
      importExcelUrl: `/scp/scpMpsFdSupplierRank/import`,
      warehouseOptions: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiSelectSupplierRankPage, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        supplierCodes: undefined,
        supplierName: undefined,
        supplierClass: undefined,
        supplierAbbreviation: undefined,
        supplierBrevityCode: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      formList: [
        {
          label: '供应商名称',
          type: "globalSelect-selectMultipleSearch",
          decorator: ['supplierCodes'],
          attrs: {
            placeholder: '请选择供应商名称',
            requestApi: '/scp/scpMpsFdSupplierRank/selectSupplierRankList',
            selectItem: { value: 'supplierCode', label: 'supplierName' },
            searchParam: 'supplierName'
          }
        },
        {
          label: '主型号',
          type: "input",
          decorator: ['series'],
          attrs: {
            placeholder: '请输入主型号'
          }
        }
      ],
      // 表格字段
      columns: [
        {
          title: '主型号',
          dataIndex: 'series',
          fixed: 'left',
          align: 'center',
          ellipsis: true,
          width: 140
        },
        {
          title: '供应商编码',
          width: 220,
          dataIndex: 'supplierCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          ellipsis: true,
          align: 'center'
        },
        {
          // 10外部 15内部
          title: '内外部',
          dataIndex: 'scpSupplierCategory',
          scopedSlots: { customRender: 'scpSupplierCategory' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '组排名',
          dataIndex: 'groupRank',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '总排名',
          dataIndex: 'allRank',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        }
      ],
      uomClassOptions: [], // 来源分类
      unitOfMeasureList: [], // 来源单位
      unitOfMeasureListNew: [] // 基本单位
    }
  },
  created () {
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    handleSuccess() {
      this.onSearch()
    },
    importChange() {
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.$nextTick(() => {
        const params = { ...this.queryParams }
        this.$refs.download.openModal(params)
      })
    },
    // 表单搜索
    onSearch (val) {
      this.queryParams = {};
      for(const key in val) {
        if(key !== 'searchFormLabel') {
          this.queryParams[key] = val[key]
        }
      }
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomList: undefined,
        status: undefined
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
